import { colors, fontWeight } from '@cobliteam/ui/theme';
import { css } from 'emotion';

export const cluster = css`
  display: flex;
  min-width: 40px;
  padding: 3px 5px;
  border-radius: 10px;
  color: ${colors.gray[12]};
  height: 20px;
  background: ${colors.gray[12]};
  border: 1px solid ${colors.white.DEFAULT};
  font-weight: ${fontWeight.medium};
  filter: drop-shadow(0px 4px 4px rgba(7, 7, 78, 0.2));
  transform: translateX(-50%);
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  & > * {
    color: ${colors.white.DEFAULT};
  }

  & > span {
    min-width: 14px;
    text-align: center;
  }
`;
